import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import useMediaListSearch from '@/src/shared/hooks/useMediaLibraryListSearch';

const ResearchPapers = props => {
  const [loading, results, cacheKey] = useMediaListSearch({
    attachmentResourceGroups: [{ Value: 1 }],
  });
  const whitepapers = { MediaLoading: loading, MediaResults: results, CachedKey: cacheKey };
  return <ContentPage specialContentDataNoAuth={whitepapers} {...props} />;
};

export async function getStaticProps() {
  return {
    props: {
      sitepageid: 72451,
    },
  };
}

export default ResearchPapers;
